import { MapRequestPayload } from '../useRequestMap/types';

export const enum RequestType {
    ONBOARDING_MAP = 'onboarding-map'
}
export type RequestQueryParams = {
    isResolved?: boolean;
    type?: RequestType;
    page?: number;
    perPage?: number;
};

export type Request = {
    createdAt: string;
    id: string;
    isResolved: boolean;
    payload: MapRequestPayload;
    type: RequestType;
    updatedAt: string;
    userID: string;
};
